module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_web_004.4535627f.png";